module.exports = __webpack_public_path__ + "static/media/occasion-back-to-school.5e12bdd4.png";